// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconCurrencyEuro } from '@tabler/icons-react';

const prestations = {
    id: 'prestations',
    title: <FormattedMessage id="prestations" />,
    icon: IconCurrencyEuro,
    type: 'group',
    url: '/ui/prestations'
};

export default prestations;
